import { Link, useLocation } from 'react-router-dom';
import clsx from 'clsx';
import { breadcrumbFor } from './NavConfig';
import { ThemeToggle } from './ThemeToggle';
import { TenantSwitcher } from './TenantSwitcher';
import { BusinessTypeSwitcher } from './BusinessTypeSwitcher';
import { PlanBadge } from './PlanBadge';
import { UserMenu } from './UserMenu';
import { WhatsNewBadge } from './WhatsNewBadge';
import { useTenantScope } from '@/app/providers/TenantScopeProvider';
import { buildScopedPath } from '@/app/routes';
import { openCommandPalette } from './CommandPalette';

interface Props {
  collapsed: boolean;
  onToggleCollapsed: () => void;
  onToggleMobile: () => void;
  onOpenPlanModal: () => void;
}

export function Header({ collapsed, onToggleCollapsed, onToggleMobile, onOpenPlanModal }: Props) {
  const loc = useLocation();
  const scope = useTenantScope();
  const bc = breadcrumbFor(loc.pathname);
  const isMac = typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.platform);

  return (
    <header className={clsx('ts-header', collapsed && 'collapsed')}>
      <button
        type="button"
        className="ts-toggle-btn ts-desktop-only"
        onClick={onToggleCollapsed}
        title={collapsed ? 'Цэсийг дэлгэх' : 'Цэсийг хумих'}
        aria-label={collapsed ? 'Цэсийг дэлгэх' : 'Цэсийг хумих'}
      >
        <i className={`bi ${collapsed ? 'bi-layout-sidebar-inset' : 'bi-layout-sidebar'}`} />
      </button>
      <button
        type="button"
        className="ts-toggle-btn ts-mobile-only"
        onClick={onToggleMobile}
        title="Цэс"
        aria-label="Цэс нээх"
      >
        <i className="bi bi-list" />
      </button>
      <div className="ts-header-titles">
        <div className="ts-header-title">{bc.title}</div>
        <nav className="ts-header-bc" aria-label="Байршил">
          <Link to={buildScopedPath('dashboard', scope)}>TseTsu</Link>
          {bc.group ? (
            <>
              <i className="bi bi-chevron-right" />
              <span>{bc.group.label}</span>
            </>
          ) : null}
          {bc.title ? (
            <>
              <i className="bi bi-chevron-right" />
              <span>{bc.title}</span>
            </>
          ) : null}
        </nav>
      </div>
      <div className="ts-header-spacer" />
      <button
        type="button"
        className="ts-header-search"
        onClick={openCommandPalette}
        title="Хуудас хайх, шилжих"
        aria-label="Хуудас хайх"
      >
        <i className="bi bi-search" />
        <span>Хайх, шилжих…</span>
        <kbd className="ts-kbd">{isMac ? '⌘' : 'Ctrl'} K</kbd>
      </button>
      <WhatsNewBadge />
      <ThemeToggle />
      <TenantSwitcher />
      <BusinessTypeSwitcher />
      <PlanBadge onClick={onOpenPlanModal} />
      <UserMenu />
    </header>
  );
}
